import {
  Place,
  RestaurantOutlined,
  KeyboardArrowDown,
  CalendarMonthOutlined,
  ScheduleOutlined,
  Person,
} from "@mui/icons-material";
import { Box, Typography, Drawer, Avatar } from "@mui/material";
import { CalendarDrawer } from "./CalendarDrawer";
import { CategoryDrawer } from "./CategoryDrawer";
import { useState } from "react";
import { useAppSelector } from "redux/hooks";
import { selectFilter } from "../saga/searchStoreSlice";

export function MobileFilter() {
  const filter = useAppSelector(selectFilter);
  const [openCategory, setOpenCategory] = useState(false);
  const [openCalendar, setOpenCalendar] = useState(false);

  const handleCategoryDrawerClose = () => {
    setOpenCategory(false);
  };

  const handleCalendarDrawerClose = () => {
    setOpenCalendar(false);
  };

  const selectedCategory = filter.genres.length + filter.scenes.length + filter.conditions.length;

  return (
    <>
      <Box display="flex" width="100%" bgcolor="white" borderRadius={1} my={1}>
        <Box
          display="flex"
          alignItems="center"
          p={1}
          flex={1}
          borderRight={1}
          borderColor="divider"
        >
          <Place color="primary" fontSize="small" sx={{ mx: 1 }} />
          <Typography sx={{ display: "flex", flex: 1 }}>
            東京都 (全域)
          </Typography>
        </Box>

        <Box
          display="flex"
          alignItems="center"
          position="relative"
          p={1}
          onClick={() => setOpenCategory(true)}
        >
          <RestaurantOutlined color="primary" fontSize="small" sx={{ mx: 1 }} />
          {selectedCategory === 0 ? (
            <Typography>指定なし</Typography>
          ) : (
            <Typography>こだわり</Typography>
          )}
          {selectedCategory !== 0 && (
            <Avatar
              sx={{
                bgcolor: "primary.main",
                fontSize: "small",
                height: "20px",
                width: "20px",
              }}
            >
              {selectedCategory}
            </Avatar>
          )}
        </Box>

        <Drawer
          key="category-drawer"
          anchor="bottom"
          open={openCategory}
          onClose={handleCategoryDrawerClose}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
          PaperProps={{
            style: {
              position: "relative",
              height: "100vh",
            },
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            width="100%"
            onClick={handleCategoryDrawerClose}
          >
            <KeyboardArrowDown fontSize="large" />
          </Box>
          <CategoryDrawer handleClose={handleCategoryDrawerClose} />
        </Drawer>
      </Box>

      <Box display="flex" width="100%" bgcolor="white" borderRadius={2} my={1}>
        <Box
          display="flex"
          alignItems="center"
          p={1}
          flex={1}
          onClick={() => setOpenCalendar(true)}
        >
          <CalendarMonthOutlined color="primary" fontSize="small" sx={{ mx: 1 }} />
          <Typography sx={{ display: "flex", flex: 1 }}>
            {filter.date ? filter.date.format("M月D日（ddd）") : "指定なし"}
          </Typography>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          py={1}
          onClick={() => setOpenCalendar(true)}
        >
          <ScheduleOutlined color="primary" fontSize="small" sx={{ mx: 1 }} />
          <Typography>{filter.time ?? "19:00"}</Typography>
        </Box>

        <Box
          display="flex"
          alignItems="center"
          p={1}
          onClick={() => setOpenCalendar(true)}
        >
          <Person color="primary" fontSize="small" sx={{ mx: 1 }} />
          <Typography>{filter.people ?? 2}</Typography>
        </Box>

        <Drawer
          key="calendar-drawer"
          anchor="bottom"
          open={openCalendar}
          onClose={handleCalendarDrawerClose}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <>
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              onClick={handleCalendarDrawerClose}
            >
              <KeyboardArrowDown fontSize="large" />
            </Box>
            <CalendarDrawer handleClose={handleCalendarDrawerClose} />
          </>
        </Drawer>
      </Box>
    </>
  );
}
